// DealersLanding.js
import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    Form,
    Badge,
    Accordion,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardCheck,
    faCameraRetro,
    faGaugeHigh,
    faCloudArrowUp,
    faArrowRight,
    faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";

const DealersLanding = () => {
    const [form, setForm] = useState({
        name: "",
        dealership: "",
        email: "",
        phone: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Dealer interest form submitted:", form);
        alert("Thanks! We’ll be in touch soon. (Form placeholder for now.)");
    };

    return (
        <>
            <style>{`
  /* ---------- Screen-only helpers ---------- */
 
   .text-primary {
      color: #82bb67 !important;
    }
`}</style>
            {/* Hero */}
            <section className="py-5 bg-dark text-light border-bottom border-secondary">
                <Container>
                    <Row className="align-items-center g-4">
                        <Col md={12}>
                            <img
                                className="logo print-hidden"
                                src="logo-light.png"
                                alt="Logo"
                                style={{ maxWidth: '250px', height: 'auto', objectFit: 'contain', marginRight: '10px' }}
                            />
                            <h1 className="display-5 fw-semibold">
                                Turn every customer visit into{" "}
                                <span className="text-primary">trust & revenue</span>.
                            </h1>
                            <p className="lead text-muted mt-3">
                                Q-caR helps dealers create transparent Digital Vehicle
                                Inspections with photos, notes, and shareable links—so customers
                                know what they are buying and your team knows they are interested.
                            </p>
                            <div className="d-flex gap-3 mt-4">
                                <Button size="lg" variant="primary" href="#contact">
                                    Request a Demo{" "}
                                    <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                                </Button>
                                {/* <Button size="lg" variant="outline-light" href="#features">
                  See Features
                </Button> */}
                            </div>
                            <div className="d-flex align-items-center gap-3 mt-4">
                                <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                                <small className="text-muted">
                                    No long-term contract • Quick setup • Works on desktop & mobile
                                </small>
                            </div>
                        </Col>
                       {/*  <Col md={5}>
                            <Card className="bg-secondary-subtle text-light border-0 shadow-sm">
                                <Card.Body>
                                    <div className="ratio ratio-16x9 rounded bg-dark-subtle d-flex align-items-center justify-content-center">
                                        <div className="text-center">
                                            <FontAwesomeIcon
                                                icon={faCameraRetro}
                                                size="2x"
                                                className="mb-3 text-secondary"
                                            />
                                            <div className="fw-semibold">DVI Viewer Preview</div>
                                            <div className="text-muted small">
                                                Photos • Notes • Status • Share Link
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col> */}
                    </Row>
                </Container>
            </section>

            {/* Subtext */}
     {/*        <section className="py-4 bg-dark text-secondary text-center">
                <Container>
                    <small>Built for independent dealers & service departments</small>
                </Container>
            </section> */}

            {/* Features */}
            <section id="features" className="py-5 bg-dark text-light border-top border-secondary">
                <Container>
                    <Row className="mb-4">
                        <Col md={8}>
                            <h2 className="fw-semibold">Why dealers choose Q-caR</h2>
                            <p className="text-muted mb-0">
                                Speed up approvals, reduce back-and-forth, and give your advisors
                                the tools they need to win customer trust.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {[
                            {
                                icon: faClipboardCheck,
                                title: "Tap-friendly DVI workflow",
                                desc: "Prebuilt checklists, clear pass/fail/recommend statuses, and notes—so techs finish inspections in minutes.",
                            },
                            {
                                icon: faCloudArrowUp,
                                title: "Photo-rich transparency",
                                desc: "Attach photos from mobile, organize evidence, and share a clean link customers can view anywhere.",
                            },
                            {
                                icon: faGaugeHigh,
                                title: "Qualified Leads",
                                desc: "Know what vehicles are in demand, and capture leads effortlessly.",
                            },
                        ].map((f, idx) => (
                            <Col md={4} key={idx}>
                                <Card className="bg-secondary text-light border-0 shadow-sm h-100">
                                    <Card.Body>
                                        <div className="mb-3">
                                            <FontAwesomeIcon
                                                icon={f.icon}
                                                className="text-primary me-2"
                                            />
                                            <span className="fw-semibold">{f.title}</span>
                                        </div>
                                        <p className="text-muted mb-0">{f.desc}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* How it works */}
            <section className="py-5 bg-body-tertiary text-light border-top border-secondary">
                <Container>
                    <Row className="mb-4">
                        <Col md={8}>
                            <h2 className="fw-semibold">How it works</h2>
                            <p className="text-muted mb-0">
                                Simple setup. Start sending beautiful, actionable inspections in a day.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        {[
                            {
                                step: "1",
                                title: "Create an inspection",
                                desc: "Scan VIN or pick a vehicle, then select your checklist.",
                            },
                            {
                                step: "2",
                                title: "Add photos & notes",
                                desc: "Capture issues with photos and recommendations your customers understand.",
                            },
                            {
                                step: "3",
                                title: "Post & capture leads",
                                desc: "Post the Q-caR Code on vehicles to capture walk-in leads",
                            },
                        ].map((s, idx) => (
                            <Col md={4} key={idx}>
                                <Card className="bg-dark border-secondary h-100">
                                    <Card.Body>
                                        <div className="display-6 fw-bold text-primary mb-2">
                                            {s.step}
                                        </div>
                                        <h5 className="fw-semibold">{s.title}</h5>
                                        <p className="text-muted mb-0">{s.desc}</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* FAQ */}
            <section className="py-5 bg-dark text-light border-top border-secondary">
                <Container>
                    <Row className="mb-4">
                        <Col md={8}>
                            <h2 className="fw-semibold">FAQs</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <Accordion flush>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>How quickly can we start?</Accordion.Header>
                                    <Accordion.Body className="bg-dark text-muted">
                                        Most dealerships are up and running the same day. We’ll guide
                                        you through a short setup and import basic vehicle data if needed.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Does this work on mobile?</Accordion.Header>
                                    <Accordion.Body className="bg-dark text-muted">
                                        Yes. Q-caR is responsive and techs can capture photos and notes
                                        from phones or tablets right at the vehicle.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Can I customize the checklist?</Accordion.Header>
                                    <Accordion.Body className="bg-dark text-muted">
                                        Absolutely—add, remove, or reorder inspection items to match
                                        your shop’s process.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact form */}
            <section id="contact" className="py-5 bg-body-tertiary text-light border-top border-secondary">
                <Container>
                    <Row className="mb-4">
                        <Col md={8}>
                            <h2 className="fw-semibold">Get in touch</h2>
                            <p className="text-muted mb-0">
                                Tell us a bit about your dealership and we’ll follow up with next steps.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4">
                        <Col md={7}>
                            <Card className="bg-dark border-secondary shadow-sm">
                                <Card.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <Row className="g-3">
                                            {[
                                                { id: "name", label: "Your Name", placeholder: "Jane Doe" },
                                                { id: "dealership", label: "Dealership", placeholder: "Acme Auto Group" },
                                                { id: "email", label: "Email", placeholder: "you@dealership.com", type: "email" },
                                                { id: "phone", label: "Phone", placeholder: "(555) 123-4567", type: "tel" },
                                            ].map((f) => (
                                                <Col md={f.id === "message" ? 12 : 6} key={f.id}>
                                                    <Form.Group controlId={`contact-${f.id}`}>
                                                        <Form.Label>{f.label}</Form.Label>
                                                        <Form.Control
                                                            type={f.type || "text"}
                                                            name={f.id}
                                                            value={form[f.id]}
                                                            onChange={handleChange}
                                                            placeholder={f.placeholder}
                                                            className="bg-secondary text-light border-0"
                                                            required={f.id !== "phone"}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            ))}
                                            <Col xs={12}>
                                                <Form.Group controlId="contact-message">
                                                    <Form.Label>What are you hoping to improve?</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={4}
                                                        name="message"
                                                        value={form.message}
                                                        onChange={handleChange}
                                                        placeholder="Tell us about your service flow, approvals, etc."
                                                        className="bg-secondary text-light border-0"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} className="d-flex justify-content-end">
                                                <Button type="submit" variant="primary">
                                                    Send Message
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={5}>
                            <Card className="bg-dark border-secondary h-100 shadow-sm">
                                <Card.Body>
                                    <h5 className="fw-semibold mb-3">What you’ll get</h5>
                                    <ul className="mb-0 text-muted">
                                        <li className="mb-2">A short discovery call to understand your workflow</li>
                                        <li className="mb-2">Guided walkthrough of Q-caR’s inspection flow</li>
                                        <li className="mb-2">Pricing and next steps</li>
                                    </ul>
                                    <div className="mt-4">
                                        <Badge bg="success" pill>
                                            Quick setup
                                        </Badge>{" "}
                                        <Badge bg="info" pill>
                                            Mobile-ready
                                        </Badge>{" "}
                                        <Badge bg="secondary" pill>
                                            No long-term contract
                                        </Badge>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Footer */}
            <footer className="py-4 bg-dark border-top border-secondary text-center text-muted small">
                © {new Date().getFullYear()} Q-caR • All rights reserved.
            </footer>
        </>
    );
};

export default DealersLanding;
